import React from 'react';
import { Field } from '../../../headless/field';
import { useFieldProps } from '../../../contexts/field-props-context';
import { type PublicTextAreaProps } from '../../../types/public-props';
import {
  BaseLabel,
  BaseError,
  BaseDescription,
  type BaseLabelComponent,
} from '../../../headless/base';

import { Input } from './input';

export interface TextAreaProps {
  children: React.ReactNode;
  asChild?: boolean;
  className?: string;
}

const Root = React.forwardRef<HTMLDivElement, TextAreaProps>((props, ref) => {
  const { children, asChild, className } = props;
  const { id } = useFieldProps<PublicTextAreaProps>();

  return (
    <Field ref={ref} id={id} className={className} asChild={asChild}>
      <Field.Input>{children}</Field.Input>
    </Field>
  );
});

Root.displayName = 'TextArea';

interface TextAreaComponent
  extends React.ForwardRefExoticComponent<
    TextAreaProps & React.RefAttributes<HTMLDivElement>
  > {
  Label: BaseLabelComponent<PublicTextAreaProps>;
  Input: typeof Input;
  Error: typeof BaseError<PublicTextAreaProps>;
  Description: typeof BaseDescription<PublicTextAreaProps>;
}

export const TextArea = Root as TextAreaComponent;
TextArea.Label = BaseLabel;
TextArea.Input = Input;
TextArea.Error = BaseError;
TextArea.Description = BaseDescription;
